import React, { createContext, useContext, useState, useEffect } from "react";
import { usePharmacy } from "./PharmacyProvider";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const { pharmacyPOS } = usePharmacy();
  const [currency, setCurrency] = useState(null);
  const rates = pharmacyPOS?.conversionRates;
  // Set default currency from allowedCurrencies after provider initializes
  useEffect(() => {
    if (pharmacyPOS?.allowedCurrencies?.length > 0) {
      setCurrency(pharmacyPOS.allowedCurrencies[0]);
    }
  }, [pharmacyPOS]);

  const getCurrencySymbol = (code = null, position = "prefix") => {
    const selectedCode =
      code ||
      currency ||
      pharmacyPOS?.allowedCurrencies?.[0] ||
      "INR";

    try {
      const formatter = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: selectedCode,
        currencyDisplay: "symbol",
      });

      // Extract only the symbol
      const parts = formatter.formatToParts(0);
      const symbol = parts.find(p => p.type === "currency")?.value || selectedCode;

      return position === "suffix" ? ` ${symbol}` : symbol;
    } catch (err) {
      // Fallback (VERY rare case)
      return position === "suffix" ? ` ${selectedCode}` : selectedCode;
    }
  };


  const convertCurrency = (amount, fromCurrency, toCurrency) => {
    if (!amount || fromCurrency === toCurrency) return amount;

    const rates = pharmacyPOS?.conversionRates;
    if (!rates || !rates[fromCurrency] || !rates[toCurrency]) {
      return amount;
    }

    // Step 1: Convert FROM currency → INR
    const amountInINR = amount / rates[fromCurrency];

    // Step 2: Convert INR → TO currency
    const convertedAmount = amountInINR * rates[toCurrency];
    return convertedAmount;
    // return Number(convertedAmount.toFixed(2));
  };

  const updateCurrency = (code) => {
    if (pharmacyPOS?.allowedCurrencies?.includes(code)) {
      setCurrency(code);
    }
  };


  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, getCurrencySymbol, allowedCurrencies: pharmacyPOS?.allowedCurrencies || [], convertCurrency, rates }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
